export const isServer: boolean = typeof window === 'undefined';

export const getUa = (ctx?) => {
  const ua =
    typeof window === 'undefined'
      ? ctx?.req?.headers?.['user-agent']?.toLowerCase()
      : window?.navigator?.userAgent?.toLowerCase();
  return ua || '';
};

export const isRobot = (ctx?) => {
  const ua = getUa(ctx);
  return [
    'googlebot',
    'msnbot',
    'slurp',
    'yahoo',
    'askjeeves',
    'fastcrawler',
    'infoseek',
    'lycos',
    'whatsapp',
    'kakaotalk-scrap',
    'facebookexternalhit',
    'alexabot',
    'Baidu-YunGuanCe-SLABot',
    'bing',
    'YandexDotBot',
    'SemrushBot',
    'curl Weee v1.0',
    'istellabot',
    'crawler',
    'spider',
    'robot',
    'bot/',
    'adsbot',
    'python-requests',
    'ELB-HealthChecker',
    'masscan',
    'Python-urllib',
    'SFDC-Callout/49.0',
    'cortex/1.0',
    'adreview/1.0',
    'SFDC-Callout/50.0',
    'TelegramBot',
    'via ggpht.com GoogleImageProxy',
    'ltx71 - (http://ltx71.com/)',
    'petalbot'
  ].some(robot => {
    return !!ua?.match(robot.toLowerCase());
  });
};

export const isFBRobot = (ctx?) => {
  const ua = getUa(ctx).toLowerCase();
  return !!ua?.match('facebookexternalhit');
};

/**
 * 判断是否app打开
 */
export const isSayWeeeApp = function (ctx?) {
  const ua = getUa(ctx);
  if (ua) {
    return ua.indexOf('weeeapp') > -1 || ua.indexOf('masgustoapp') > -1;
  } else {
    return false;
  }
};

/**
 * weee app的安卓手机
 */
export function isWeeeAndroid(ctx?) {
  const result = isSayWeeeApp(ctx) && !isIOS(ctx);
  return result;
}

/**
 * 判断是否是微信游览器
 */
export function isWeixinBrowser(ctx?) {
  const ua = getUa(ctx);
  return /micromessenger/i.test(ua) || /windows phone/i.test(ua);
}

/**
 * 判断是否为安卓手机
 */
export function isAndroid(ctx?) {
  const ua = getUa(ctx);
  return /android/i.test(ua);
}

/**
 * 判断是否是手机浏览器
 */
export function isMobileBrowser(ctx?) {
  const ua = getUa(ctx);
  // return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera|Mini/i.test(ua);
  return /mobile|nokia|iphone|android|samsung|htc|blackberry|WAP/i.test(ua);
}

export const isMobile = isMobileBrowser;

/**
 * 判断是否在抖音客户端打开
 */
export function isTiktokBrowser(ctx?) {
  const ua = getUa(ctx);
  return /musical|trill/i.test(ua);
}

/**
 * 判断是否在facebook客户端打开
 */
export function isFacebookBrowser(ctx?) {
  const ua = getUa(ctx);
  return /(FBAN|FBAV)/i.test(ua);
}

/**
 * 判断是否在instagram客户端打开
 */
export function isInstagramBrowser(ctx?) {
  const ua = getUa(ctx);
  return /instagram/i.test(ua);
}

/**
 * 是否是ios 不是ios就是安卓
 * @param ctx
 */
export const isIOS = function (ctx?) {
  const ua = getUa(ctx);
  if (ua) {
    return !!ua?.match(/(iPad|iPhone|iPod)/i);
  } else {
    return false;
  }
};

/**
 *
 * @param ctx ios的safari
 */
export const isSafari = function (ctx?) {
  const ua = getUa(ctx).toLowerCase();
  if (ua) {
    return ua.indexOf('safari') > -1 && ua.indexOf('chrome') == -1;
  } else {
    return false;
  }
};

export const isAlipayBrowser = function (ctx?) {
  const ua = getUa(ctx);
  return /alipay/i.test(ua);
};

export const isKaKaoBrowser = function (ctx?) {
  const ua = getUa(ctx);
  return /kakaotalk/i.test(ua);
};

export const isFBBrowser = function (ctx?) {
  const ua = getUa(ctx);
  return /fba(n|v)/i.test(ua);
};

/**
 * 需要在服务端调用, 否则高度会抖动
 * @param ctx 必传
 * @url 参数中的fullscreen=1 且 statusBarHeight > 0
 * @returns
 */
export const getAppStatusBarHeight = function (ctx) {
  const isApp = isSayWeeeApp(ctx);
  let height = 0;
  if (isApp) {
    const getUrlParams = url => {
      try {
        const arrSearch = url.split('?').pop().split('#').shift().split('&');
        let obj = {};
        arrSearch.forEach(item => {
          const [k, v] = item.split('=');
          obj[k] = v;
          return obj;
        });
        return obj;
      } catch (err) {
        return {};
      }
    };
    const query = getUrlParams(ctx.req.url);
    if (String(query['fullscreen']) === '1' && query['statusBarHeight']) {
      if (Number(query['statusBarHeight']) > 0) {
        height = Number(query['statusBarHeight']);
      } else {
        if (query['statusBarHeight'].includes(',')) {
          height = Number(query['statusBarHeight'].split(',')[0]);
        }
        if (query['statusBarHeight'].includes('%2C')) {
          height = Number(query['statusBarHeight'].split('%2C')[0]);
        }
      }
    }
  }
  return height;
};

/**
 *
 * @param ctx chrome
 * mobile chrome is 'crios'
 */
export const isChrome = function (ctx?) {
  const ua = getUa(ctx).toLowerCase();
  if (ua) {
    return (ua.indexOf('chrome') > -1 || ua.indexOf('crios') > -1) && ua.indexOf('safari') > -1;
  } else {
    return false;
  }
};
